<template>
  <div class="video-popup">
    <div class="video-content">
      <img v-show="!isShowVideo" :src="coverUrl" alt="">
      <template v-if="isAndroid">
        <video v-show="isShowVideo" :id="`myVideo_${shorexBannerIndex}`" :controls="false" :src="videoUrl"
               @fullscreenchange="handleFullscreenChange"
               :poster="coverUrl"
               controlsList="nodownload noremoteplayback noplaybackrate"
               disablePictureInPicture
        ></video>
      </template>
      <template v-else>
        <video  v-show="isShowVideo"
                class="video-js vjs-default-skin vjs-big-play-centered"
                :id="`playerId_${shorexBannerIndex}`">
          <source :src="videoUrl" />
        </video>
      </template>

      <div class="videoPlayBtn" @click="onChangeVideoPlay">
        <img class="videoBtn" src="https://resource.rcclchina.com.cn/paySuccess/videoBtn.png" alt="">
        <div v-if="isShowTextBtn" class="videoTextBtn">
          <img src="https://resource.rcclchina.com.cn/paySuccess/videoTextBtn.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
export default {
  props: {
    videoUrl:{
      type: String,
      default: ''
    },
    coverUrl:{
      type: String,
      default: ''
    },
    isShowTextBtn:{
      type: Boolean,
      default: false
    },
    videoId:{
      type: Number,
      default: 0
    },
    shorexBannerIndex:{
      type: String,
      default: ''
    },
  },
  data () {
    return {
      isFullscreen: false,
      isShowVideo:false,
      isPause:false,
      videoPlayer:'',
      isAndroid: false,
      videoPlayerAndroid:''
    }
  },
  mounted() {
    this.isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
    if(!this.isAndroid)this.videoInit()
  },
  watch:{
    videoId(val){
      if(val){
        if(!this.isAndroid)this.videoInit()
      }
    }
  },
  methods:{
    videoInit(){
      
      this.videoPlayer = videojs('playerId_'+this.shorexBannerIndex, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        // 设置视频播放器的显示宽度（以像素为单位）
        width: "100%",
        // 设置视频播放器的显示高度（以像素为单位）
        height: "100%",
        controlBar: {
          playToggle: true
        },

      });
      this.videoPlayer.on('fullscreenchange', ()=> {
        if(!this.videoPlayer.isFullscreen_){
          if(!this.isAndroid){
            this.videoPlayer.pause()
            this.videoPlayer.currentTime(0)
            this.isShowVideo = false
          }
        }
      });
    },
    //   全屏
    async fullScreen() {

      this.isShowVideo = true
      // 点击播放按钮重新添加视频url
      this.videoPlayerAndroid.setAttribute('src',this.videoUrl)
      this.onChangeVideoEmit()
      this.videoPlayerAndroid.currentTime = 0
      await this.videoPlayerAndroid.play();
      if (!this.isFullscreen) {
        await this.enterFullscreen();
      } else {
        this.exitFullscreen();
      }
    },
    // 进入全屏逻辑
    async enterFullscreen() {
      // await video.play()
      if (this.videoPlayerAndroid.requestFullscreen) {
        await this.videoPlayerAndroid.requestFullscreen();
      } else if (this.videoPlayerAndroid.mozRequestFullScreen) { // Firefox
        await this.videoPlayerAndroid.mozRequestFullScreen();
      } else if (this.videoPlayerAndroid.webkitRequestFullscreen) { // Chrome, Safari 和 Opera
        await this.videoPlayerAndroid.webkitRequestFullscreen();
      } else if (this.videoPlayerAndroid.msRequestFullscreen) { // IE/Edge
        await this.videoPlayerAndroid.msRequestFullscreen();
      }
    },
    // 退出全屏逻辑
    exitFullscreen() {
      const video = this.videoPlayerAndroid
      if (video.exitFullscreen) {
        video.exitFullscreen();
      } else if (video.mozCancelFullScreen) {
        video.mozCancelFullScreen();
      } else if (video.webkitExitFullscreen) {
        video.webkitExitFullscreen();
      } else if (video.msExitFullscreen) {
        video.msExitFullscreen();
      }
      this.isFullscreen = false;
    },
    handleFullscreenChange() {
      // 更新全屏状态
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      if(!this.isFullscreen){
        // const video = this.videoPlayerAndroid
        this.videoPlayerAndroid.pause()
        this.isShowVideo = false
      }
    },
    onChangeVideoPlay(){

      if(!this.isAndroid){
        this.videoPlayer.play()
      }else{
        
        this.videoPlayerAndroid = document.getElementById(`myVideo_${this.shorexBannerIndex}`);
        // this.videoPlayerAndroid.play()
        // this.isShowVideo = true
        this.fullScreen()
      }
    },
    // 播放视频触发事件
    onChangeVideoEmit(){
      this.$emit('onChangeVideo')
    },
  }
}
</script>
<style scoped lang="less">
.video-popup{
  width: 100%;
  height: 100%;
}
.video-content{
  width: 100%;
  height: 100%;
  position: relative;
  & video{
    width: 100%;
    height: 100%;
  }
  & img{
    width: 100%;
    height: 100%;
  }
  & .videoPlayBtn{
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;
    align-items: center;
    transform: translate(-50%, -50%);
    & .videoBtn{
      width: 50px;
      height: 50px;
      display: block;
    }
    & .videoTextBtn{
      width: 156px;
      height: 33px;
      margin: 0 auto;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>